<template>
  <div id="journal">
    <!-- all_in -->
    <div class="break_box">
      <Breadcrumb>
        <breadcrumbs></breadcrumbs>
      </Breadcrumb>
    </div>
    <div class="con_all" v-if="!$route.meta.keepAliveSub">
      <div class="con_box2">
        <table width="100%">
          <tr>
            <td>{{showPage.type}}</td>
          </tr>
          <tr v-for="(typeobj,index) in types" :key="index" @click="pushToJournal(typeobj)">
            <td style="cursor: pointer;">{{showName(typeobj)}}</td>
          </tr>
        </table>
      </div>
    </div>
    <router-view v-else :type="nowType"></router-view>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message, ShowPage } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'journal',
  data() {
    return {
      types: [],
      nowType: '',
      showPage: ShowPage(sessionStorage.getItem('locale')),
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.initType();
    },
    initType() {
			this.getTypeData();
		},
    initNowType() {
      if(this.$route.params.journalid) {
        this.types.some(type => {
          if(type.id = this.$route.params.journalid) {
            this.nowType = type;
            return true;
          }
        });
      }
    },
    getTypeData() {
			axios.get(API.code + `?type=1`)
      .then(response => {
        this.types = response.data.filter(data => {
            return data.trash !== 1;
          });
        this.initNowType();
      })
      .catch(error => {
        GetErrorHandler.bind(this)(error);
      });
		},
    
    pushToJournal(typeobj) {
      this.nowType = typeobj;
      this.$router.push({ name: 'journal_info', params: { journalid: typeobj.id } });
    },
    
    showName(typeobj) {
      let show = {'CH': typeobj.nameCh, 'EN': typeobj.nameEn}
      return show[sessionStorage.locale];
    },
  },
}

</script>
<style lang="scss">
#journal {
  table,
  th,
  td {
    border: 1px solid #ccc;
    border-collapse: collapse;
    padding: 10px;
  }
  tr {
    &:first-child {
      background-color: #eee;
    }
  }
}

</style>



// WEBPACK FOOTER //
// Journal.vue?4e95f0f8